import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    GET_USER,
    UPDATE_MY_USER,
    //UPDATE_USER,
    SHOW_MESSAGE,
    //USER_TOKEN_SET,
    HIDE_MESSAGE,
    //UPDATE_USER_SETTING,
    GET_USER_BUDGET,
    GET_USER_BUDGET_WORK_DAYS,
    //UPDATE_USER_BUDGET,
    GET_USER_BUDGET_UTPRIS,
    GET_USER_BUDGET_ANTAL,
    GET_USER_BUDGET_ACTIVITIES,
    GET_USER_BUDGET_MOTE,
    FETCH_START_GET_USER,
    //GET_USER_INTEGRATION,
    //UPDATE_USER_INTEGRATION,
    ON_START_UPDATE_USER_FLAGS,
    ON_UPDATE_USER_FLAGS,
    ON_ERROR_UPDATE_USER_FLAGS,GET_USER_UPDATE_BUDGET_ORDERVARDER,
    GET_USER_UPDATE_BUDGET_MOTE,GET_USER_BUDGET_ORDERVARDE,
    ON_START_PERATER_USER,  ON_PERATER_USER,  ON_ERROR_PERATER_USER,
    ON_START_CONNENCT_OUTLOOK,ON_CONNENCT_OUTLOOK,ON_ERROR_CONNENCT_OUTLOOK,
    ON_START_EJAKTIV_USER,  ON_EJAKTIV_USER,  ON_ERROR_EJAKTIV_USER,ON_TAEJAKTIV_USER,
    ON_START_UPDATE_LOBBY_CUSTOM,ON_UPDATE_LOBBY_CUSTOM,ON_ERROR_UPDATE_LOBBY_CUSTOM,
    ON_START_UPDATE_USER_KUND_TABLE_COLUMN,
    ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN,
    ON_UPDATE_USER_KUND_TABLE_COLUMN,
    ON_START_GET_USER_KUND_TABLE_COLUMN,
    ON_ERROR_GET_USER_KUND_TABLE_COLUMN,
    ON_GET_USER_KUND_TABLE_COLUMN,

    ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN,
    ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN,
    ON_GET_USER_OFFERT_ART_TABLE_COLUMN,
    ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN,
    ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN,
    ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN,

    ON_CLOSE_USER_TOASTR,GET_USER_CONNECT,
    FETCH_START_SET_UNAUTHE,ON_MESSAGE_KUND,ON_START_MESSAGE_KUND
  } from "../constants/ActionTypes";
  import axios from 'util/Api';
  import setAuthorizationToken from '../util/setAuthorizationToken';
  import {RefreshUserInterface} from 'actions'
  //import jwtDecode from 'jwt-decode';
  import {userSignOut} from 'actions'
  import {isUndefined} from 'lodash'
  import { translate } from "../util/intlHelper";
  import {encrypt,decrypt} from 'actions'


  const setInitUrl = (url) => {
    return {
      type: INIT_URL,
      payload: url
    };
  };
   const showAuthMessage = (message) => {
    return {
        type: SHOW_MESSAGE,
        payload: message
    };
  };

  const getClientIp = async () => {
    let Ipadress='0.0.0.0'
    /*  await fetch('http://ip-api.com/json')
      .then(response => response.json())
      .then(data => {console.log(data)
        Ipadress= data.query || "0.0.0.0"});
       */
        return Ipadress
  }

  export const getUser = (userid, Afid) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
     //const ipAdress='0.0.0.0'
     const ipAdress ='0.0.0.0'
     dispatch({type: FETCH_START_GET_USER});
      axios.get('users/getUser', { params:encrypt(JSON.stringify({
        userid:userid,Afid:Afid, ipAdress
      })), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then( data => {
        console.log("getUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getEsigneringHistory1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: GET_USER, payload: ndate.results[0]});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getEsigneringHistory2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
              
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      }); 
    }
  }
  //update user no function
  export const updateMyUser = (user,CurrentUser) => {
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress ='0.0.0.0'
      dispatch({type: FETCH_START});
      axios.put('users',{
        body: encrypt(JSON.stringify({
          user: JSON.stringify(user),
          CurrentUser: CurrentUser,
          ipAdress
        }))
    },
      {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
      }).then( data  => {
        console.log("updateMyUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getEsigneringHistory1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: UPDATE_MY_USER, payload: ndate.user});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("updateMyUser2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
        
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      });
    }
  };
  //getUserBudgetUtpris
  export const getUserBudgetUtpris = (userid,year) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
     const ipAdress ='0.0.0.0'
     dispatch({type: FETCH_START});
      axios.get('users/BudgetUtpris', { params:encrypt(JSON.stringify({
        userid:userid,year:year,ipAdress})), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then( data => {
        console.log("getUserBudgetUtpris: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudgetUtpris1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: GET_USER_BUDGET_UTPRIS, payload: ndate.results[0]});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudgetUtpris2: ", endata);
          let ndate = JSON.parse(endata)  
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }

      
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      }); 
    }
  }
  
  //GET_USER_BUDGET_UTPRIS,
  //updateUserBudgetUtpris
  export const updateUserBudgetUtpris = (userid,year,CBudget) => {
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress ='0.0.0.0'
      dispatch({type: FETCH_START});
      axios.put('users/BudgetUtpris', 
        {
          body: encrypt(JSON.stringify({
            userid: userid,
            year: year,
            CBudget:CBudget,ipAdress
          }))
      },
        {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
      }).then( data => {
        console.log("getUserBudget: ", data);
        if(data.data.success){  
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudgetUtpris1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_USER_BUDGET_UTPRIS, payload: ndate.Budget});
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudget2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      });
    }
  };
  //getUserBudgetAntal
  export const getUserBudgetAntal = (userid,year) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
     const ipAdress ='0.0.0.0'
     dispatch({type: FETCH_START});
      axios.get('users/BudgetAntal', { params:encrypt(JSON.stringify({userid:userid,year:year,ipAdress})), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then( data => {
        console.log("getUserBudgetAntal: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudgetAntal1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: GET_USER_BUDGET_ANTAL, payload: ndate.results[0]});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudgetAntal2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      }); 
    }
  }
  //GET_USER_BUDGET_ANTAL
  //updateUserBudgetAntal
  export const updateUserBudgetAntal = (userid,year,CBudget) => {
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress ='0.0.0.0'
      dispatch({type: FETCH_START});
      axios.put('users/BudgetAntal',{
        body: encrypt(JSON.stringify({
          userid: userid,
          year: year,
          CBudget:CBudget,ipAdress
        }))
    }, {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
      }).then( data => {
        console.log("updateUserBudgetAntal: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateUserBudgetAntal1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_USER_BUDGET_ANTAL, payload: ndate.Budget});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("updateUserBudgetAntal2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      });
    }
  };
  //getUserBudget
  export const getUserBudget = (userid,year) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
     const ipAdress ='0.0.0.0'
     dispatch({type: FETCH_START});
      axios.get('users/Budget', { params:encrypt(JSON.stringify({ userid:userid,year:year,ipAdress})), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then( data => {
        console.log("getUserBudget: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudget1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: GET_USER_BUDGET, payload: ndate.results[0]});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudget2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      }); 
    }
  }
  //update user Budget 
  export const updateUserBudget = (userid,year,CBudget) => {
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress ='0.0.0.0'
      dispatch({type: FETCH_START});
      axios.put('users/Budget', {
        body: encrypt(JSON.stringify({
          userid: userid,
          year: year,
          CBudget:CBudget,ipAdress
        }))
    },{
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
      }).then( data => {
        console.log("getUserBudget: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudget1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_USER_BUDGET, payload: ndate.Budget});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudget2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      });
    }
  };
  export const getUserBudgetWorkDays = (userid,Afid,year) =>{
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
     const ipAdress ='0.0.0.0'
     dispatch({type: FETCH_START});
      axios.get('users/BudgetWorkDays', { params:encrypt(JSON.stringify({ userid:userid,year:year,Afid:Afid,ipAdress} )), 
      headers: { 'Authorization': `Bearer ${jwt}`} }
      ).then( data => {
        console.log("getUserBudget: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudgetWorkDays1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: GET_USER_BUDGET_WORK_DAYS, payload: ndate.results[0]});
         }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudgetWorkDays2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
      
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      }); 
    }
  }
  //update user Budget 
  export const updateUserBudgetWorkDays = (userid,year,CBudget) => {
    const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress ='0.0.0.0'
      dispatch({type: FETCH_START});
      axios.put('users/BudgetWorkDays', {
        body: encrypt(JSON.stringify({
          userid: userid,
          year: year,
          CBudget:CBudget,ipAdress
        }))
    },{
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }
      }).then( data => {
        console.log("getUserBudget: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getUserBudgetWorkDays1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_USER_BUDGET_WORK_DAYS, payload: ndate.Budget});
        }
        else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getUserBudgetWorkDays2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: FETCH_ERROR, payload: ndate.error});
        }
       
      }).catch(function (error) {
        dispatch({type: FETCH_ERROR, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      });
    }
  };
//getMoteBudgetByUser
export const getMoteBudgetByUser = (userid,year) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
   const ipAdress ='0.0.0.0'
   dispatch({type: FETCH_START});
    axios.get('users/MoteBudget', { params:encrypt(JSON.stringify({ userid:userid,year:year,ipAdress }  )), 
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data  => {
      console.log("getMoteBudgetByUser: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUserBudgetMote1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: GET_USER_BUDGET_MOTE, payload: ndate.Budget});
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getMoteBudgetByUser2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
       }
      
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
       //   dispatch(userSignOut())
       } 
    }); 
  }
}
//getOrderVardeBudgetByUser
export const getOrderVardeBudgetByUser = (userid,year) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
   dispatch({type: FETCH_START});
    axios.get('users/OrderVardeBudget', { params:encrypt(JSON.stringify({ userid:userid,year:year,ipAdress})), 
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data  => {
      console.log("getOrderVardeBudgetByUser: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getOrderVardeBudgetByUser1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: GET_USER_BUDGET_ORDERVARDE, payload: ndate.Budget});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getOrderVardeBudgetByUser2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
       //   dispatch(userSignOut())
       } 
    }); 
  }
}
//getUserABudget
export const getUserABudget = (userid,year) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
   dispatch({type: FETCH_START});
    axios.get('users/ActivitiesBudget', { params:encrypt(JSON.stringify({
      userid:userid,year:year,ipAdress })), 
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data  => {
      console.log("getUserABudget: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUserABudget1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: GET_USER_BUDGET_ACTIVITIES, payload: ndate.data});
      }else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUserABudget2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
     //     dispatch(userSignOut())
       } 
    }); 
  }
}
//updateUserABudget
export const updateUserABudget = (userid,year,fas,ABudget) => {
 const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
    dispatch({type: FETCH_START});
    axios.put('users/ActivitiesBudget', {
      body: encrypt(JSON.stringify({
        userid: userid,
        year: year,
        fas:fas+1,
        ABudget:ABudget,ipAdress
      }))},
      {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      },
      
  }).then( data => {
      console.log("updateUserABudget: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateUserABudget1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_USER_BUDGET, payload: ndate.Budget});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateUserABudget2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
     
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
     //     dispatch(userSignOut())
       } 
    });
  }
};
//updateUserFlags
export const updateUserFlags =  (userid,Afid,user,Meta,Value) =>{
 const jwt =  JSON.parse(localStorage.token);
    return async (dispatch) => {
      const ipAdress ='0.0.0.0'
      dispatch({type: ON_START_MESSAGE_KUND,payload:translate("Action.Account.Flags.updating")});
      dispatch({type: ON_START_UPDATE_USER_FLAGS});
       axios.put('users/Flags/update', {
       method: 'PUT',
       body: encrypt(JSON.stringify({
         Afid:Afid,
         userid:userid,
         user:user,
         Meta:Meta,
         Value:Value,ipAdress
       }))},
       {
       headers: {
           'content-type': 'application/json',
           'Authorization':   `Bearer ${jwt}`
       }       
   }).then( data  => {
       console.log("CopytoKDAvRows: ", data);
       if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_USER_FLAGS, payload: ndate.results});
        dispatch({type: ON_MESSAGE_KUND, payload:translate("Action.Account.Flags.update")});
       }
       else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_USER_FLAGS, payload: ndate.error});
       }
       
      }).catch(function (error) {
        dispatch({type: ON_ERROR_UPDATE_USER_FLAGS, payload: error.message});
           if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
      });/**/
    }
 }
//ConnectToOutlook no Function
export const ConnectToOutlook = (Afid,userid,outlook)=>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
    dispatch({type: ON_START_CONNENCT_OUTLOOK});
     axios.put('users/user/outlook/connect', {
     method: 'PUT',
     body: encrypt(JSON.stringify({
       Afid:Afid,
       userid:userid,
       outlook:outlook,
       ipAdress
     }))} ,
     {
     headers: {
         'content-type': 'application/json',
         'Authorization':   `Bearer ${jwt}`
     }       
 }).then( data => {
     console.log("ConnectToOutlook: ", data);
     if(data.data.success){
      let endata = decrypt(data.data.encryptedData,data.data.iv)
      console.log("ConnectToOutlook1: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_CONNENCT_OUTLOOK, payload: ndate.results});
     }
     else{
      let Data = isUndefined(data.data.error)?data.data:data.data.error
      let endata = decrypt(Data.encryptedData,Data.iv)
      console.log("ConnectToOutlook2: ", endata);
      let ndate = JSON.parse(endata)
      dispatch({type: ON_ERROR_CONNENCT_OUTLOOK, payload: ndate.error});
     }

    }).catch(function (error) {
      dispatch({type: ON_ERROR_CONNENCT_OUTLOOK, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          dispatch(userSignOut())
       } 
    });
  }
}
//EjAktiverUserid
export const EjAktiverUserid =  (userid,Afid,EjAktiverUserid,isArchived) =>{
  const jwt =  JSON.parse(localStorage.token);
     return async (dispatch) => {
       const ipAdress='0.0.0.0'
       dispatch({type: ON_START_EJAKTIV_USER});
        axios.put('users/user/EjAktivera', {
        method: 'PUT',
        body: encrypt(JSON.stringify({
          Afid:Afid,
          userid:userid,
          isArchived:isArchived,
          EjAktiverUserid:EjAktiverUserid,
          ipAdress
        }))},
        {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then( data => {
        console.log("EjAktiverUserid: ", data);
        if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        if(parseInt(isArchived) === 1){
          dispatch({type: ON_TAEJAKTIV_USER, payload: ndate.results});
        }
        else{
          dispatch({type: ON_EJAKTIV_USER, payload: ndate.results});
        }
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getEsigneringHistory2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_EJAKTIV_USER, payload: ndate.results});
        }
         
       }).catch(function (error) {
         dispatch({type: ON_ERROR_EJAKTIV_USER, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
      //    dispatch(userSignOut())
       } 
       });/**/
     }
  }
//UpdateUserMBudget
export const UpdateUserMBudget = (userid,year,CBudget) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
    dispatch({type: FETCH_START});
    axios.put('users/MoteBudget', {
      body: encrypt(JSON.stringify({
        userid: userid,
        year: year,
        CBudget:CBudget,
        ipAdress
      }))},
      {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      },
     
  }).then( data  => {
      console.log("UpdateUserMBudget: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("UpdateUserMBudget1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_USER_UPDATE_BUDGET_MOTE, payload: ndate.Budget});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("UpdateUserMBudget2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
      //  dispatch(userSignOut())
     } 
    });
  }
};
//UpdateUserOVBudget
export const UpdateUserOVBudget = (userid,year,CBudget) => {
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
    dispatch({type: FETCH_START});
    axios.put('users/OrderVardeBudget', {
      body: encrypt(JSON.stringify({
        userid: userid,
        year: year,
        CBudget:CBudget,
        ipAdress
      }))},
      {
      headers: {
          'content-type': 'application/json',
          'Authorization':   `Bearer ${jwt}`
      },
     
  }).then( data => {
      console.log("UpdateUserOVBudget: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("UpdateUserOVBudget: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_USER_UPDATE_BUDGET_ORDERVARDER, payload: ndate.Budget});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("UpdateUserOVBudget: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
         if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
     if(error.message === "Network Error"){
        //reload and remove token 
      //  dispatch(userSignOut())
     } 
    });
  }
};
//PerSAterThisUser
export const PerSAterThisUser =  (userid,Afid,PerAkterUserid) =>{
  const jwt =  JSON.parse(localStorage.token);
     return async (dispatch) => {
      const ipAdress='0.0.0.0'
       dispatch({type: ON_START_PERATER_USER});
        axios.put('users/user/ResetPerAter', {
         body: encrypt(JSON.stringify({
          Afid:Afid,
          userid:userid,
          PerAkterUserid:PerAkterUserid,
          ipAdress
        }))},
        {
        headers: {
            'content-type': 'application/json',
            'Authorization':   `Bearer ${jwt}`
        }       
    }).then( data => {
        console.log("PerSAterThisUser: ", data);
        if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("getEsigneringHistory1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_PERATER_USER, payload: ndate.results});
        }else{
          let Data = isUndefined(data.data.error)?data.data:data.data.error
          let endata = decrypt(Data.encryptedData,Data.iv)
          console.log("getEsigneringHistory2: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_ERROR_PERATER_USER, payload: ndate.error});
        }
         
       }).catch(function (error) {
         dispatch({type: ON_ERROR_PERATER_USER, payload: error.message});
            if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
       //   dispatch(userSignOut())
       } 
       });/**/
     }
  }
  
export const updateUserKundTableColumn = (Afid, Userid, Key, Value) => {
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_USER_KUND_TABLE_COLUMN});
     axios.put('users/kundTableColumn', {
      body: encrypt(JSON.stringify({
        Afid, Userid, Key, Value,
      })),
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }  
    }).then( data => {
      console.log("updateUserKundTableColumn: ", data);
      if(data.data.success){
          let endata = decrypt(data.data.encryptedData,data.data.iv)
          console.log("updateUserKundTableColumn1: ", endata);
          let ndate = JSON.parse(endata)
          dispatch({type: ON_UPDATE_USER_KUND_TABLE_COLUMN, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateUserKundTableColumn2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN, payload: ndate.error});
      }
    
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_USER_KUND_TABLE_COLUMN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
}
export const getUserKundTableColumns = (Afid, Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
   const ipAdress ='0.0.0.0'
   dispatch({type: ON_START_GET_USER_KUND_TABLE_COLUMN});
    axios.get('users/kundTableColumn', { params:encrypt(JSON.stringify({Afid, Userid})), 
    headers: { 'Authorization': `Bearer ${jwt}`} 
  }
    ).then( data  => {
      console.log("getUserKundTableColumns: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUserKundTableColumns1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_USER_KUND_TABLE_COLUMN, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUserKundTableColumns2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_USER_KUND_TABLE_COLUMN, payload: ndate.error});
      }
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_USER_KUND_TABLE_COLUMN, payload: error.message});
         if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        // dispatch(userSignOut())
     } 
    }); 
  }
}
export const updateUserOffertArtTableColumn = (Afid, Userid, Key, Value) => {
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_USER_OFFERT_ART_TABLE_COLUMN});
     axios.put('users/offertArtTableColumn', {
      body: encrypt(JSON.stringify({
        Afid, Userid, Key, Value,
      })),
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }  
    }).then( data => {
      console.log("updateUserOffertArtTableColumn: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("updateUserOffertArtTableColumn1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_USER_OFFERT_ART_TABLE_COLUMN, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("updateUserOffertArtTableColumn2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_USER_OFFERT_ART_TABLE_COLUMN, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
}
export const getUserOffertArtTableColumns = (Afid, Userid) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
   const ipAdress ='0.0.0.0'
   dispatch({type: ON_START_GET_USER_OFFERT_ART_TABLE_COLUMN});
    axios.get('users/offertArtTableColumn', { params:encrypt(JSON.stringify({
      Afid, Userid })), 
    headers: { 'Authorization': `Bearer ${jwt}`} 
  }
    ).then( data => {
      console.log("getUserKundTableColumns: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getEsigneringHistory1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_GET_USER_OFFERT_ART_TABLE_COLUMN, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getEsigneringHistory2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN, payload: ndate.error});
      }
    
    }).catch(function (error) {
      dispatch({type: ON_ERROR_GET_USER_OFFERT_ART_TABLE_COLUMN, payload: error.message});
         if(!isUndefined(error.response)){
      if (error.response.status === 401) {
        dispatch({type: FETCH_START_SET_UNAUTHE});
       } 
     } 
     if(error.message === "Network Error"){
        //reload and remove token 
        // dispatch(userSignOut())
     } 
    }); 
  }
}
//getUserConnet
export const getUserConnet = (userid,AuthId) =>{
  const jwt =  JSON.parse(localStorage.token);
  return async (dispatch) => {
    const ipAdress ='0.0.0.0'
   dispatch({type: FETCH_START});
    axios.get('users/connect', { params:encrypt(JSON.stringify({
      userid:userid,AuthId:AuthId,ipAdress })), 
    headers: { 'Authorization': `Bearer ${jwt}`} }
    ).then( data => {
      console.log("getUserConnet: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("getUserConnet1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: GET_USER_CONNECT, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("getUserConnet2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: FETCH_ERROR, payload: ndate.error});
      }
    
    }).catch(function (error) {
      dispatch({type: FETCH_ERROR, payload: error.message});
       if(error.message === "Network Error"){
          //reload and remove token 
     //     dispatch(userSignOut())
       } 
    }); 
  }
}

//onCloseUserToaster
export const onCloseUserToaster = () => {
  return (dispatch) => {
    dispatch({type:ON_CLOSE_USER_TOASTR});
  }
}
//onSaveThisLobby
export const onSaveThisLobby = (Userid,Afid,Layouts,layoutData) => {
  const jwt =  JSON.parse(localStorage.token);
   return (dispatch) => {
     dispatch({type: ON_START_UPDATE_LOBBY_CUSTOM});
     axios.put('kontos/Lobby/custom', {
      body: encrypt(JSON.stringify({
        Userid:Userid,
        Afid:Afid,
        Layouts:JSON.stringify(Layouts),
        layoutData:JSON.stringify(layoutData)
      })),
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization':   `Bearer ${jwt}`
      }  
    }).then( data  => {
      console.log("onSaveThisLobby: ", data);
      if(data.data.success){
        let endata = decrypt(data.data.encryptedData,data.data.iv)
        console.log("onSaveThisLobby1: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_UPDATE_LOBBY_CUSTOM, payload: ndate.results});
      }
      else{
        let Data = isUndefined(data.data.error)?data.data:data.data.error
        let endata = decrypt(Data.encryptedData,Data.iv)
        console.log("onSaveThisLobby2: ", endata);
        let ndate = JSON.parse(endata)
        dispatch({type: ON_ERROR_UPDATE_LOBBY_CUSTOM, payload: ndate.error});
      }
     }).catch(function (error) {
       dispatch({type: ON_ERROR_UPDATE_LOBBY_CUSTOM, payload: error.message});
          if(!isUndefined(error.response)){
        if (error.response.status === 401) {
          dispatch({type: FETCH_START_SET_UNAUTHE});
         } 
       } 
       if(error.message === "Network Error"){
          //reload and remove token 
          //dispatch(userSignOut())
       } 
     });
   }
}
//onGetUserEmailGroups
